const moment = require('moment');

export class DateTimeParser {

    public static dateOffsetParser = (dateTime: string | Date) => {

        let utcOffset = moment.parseZone(dateTime).utcOffset();

        if (utcOffset === 0) {
            return moment(dateTime).utc();
        }
       
        return moment(dateTime);
    }

    public static generateTimeSlots = (from: Date, toHour: number, locale: string = 'pt-BR'): string[] => {
        const slots: string[] = [];
        const start = new Date(from);

        if (start.getMinutes() > 0) {
            start.setMinutes(start.getMinutes() <= 30 ? 30 : 0);
            if (start.getMinutes() === 0) start.setHours(start.getHours() + 1);
        }

        start.setSeconds(0);
        start.setMilliseconds(0);

        while (start.getHours() < toHour) {
            const formatted = start.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' });
            slots.push(formatted);

            start.setMinutes(start.getMinutes() + 30);
        }

        return slots;
    };

    public static getDisabledWeekends = (start: Date, daysAhead = 60): Date[] => {
        const disabled: Date[] = [];
        const date = new Date(start);

        for (let i = 0; i < daysAhead; i++) {
            const day = date.getDay();
            if (day === 0 || day === 6) {
                disabled.push(new Date(date));
            }
            date.setDate(date.getDate() + 1);
        }

        return disabled;
    };
}